import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../common/Header";
import HeroSection from "./HeroSection";
import AboutSection from "./AboutSection";
import Footer from "../../common/Footer";
import PrivacySection from "./PrivacySection";
import TipSection from "./TipSection";
import LandingLoadingScreen from "./LandingLoadingScreen";
import EmergencyDisclaimer from "./EmergencyDisclaimer";
import TermsConditionsModal from "./TermsConditionsModal";

const Landing: FC = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Show loading screen for 2 seconds
    const loadingTimeout = setTimeout(() => setIsLoading(false), 2000);

    const disclaimerAccepted = localStorage.getItem("disclaimerAccepted");
    if (!disclaimerAccepted) {
      setShowDisclaimer(true);
    }

    return () => clearTimeout(loadingTimeout);
  }, []);

  const handleDisclaimerAccept = () => {
    localStorage.setItem("disclaimerAccepted", "true");
    setShowDisclaimer(false);
  };

  const handleDisclaimerClose = () => {
    setShowDisclaimer(false);
  };

  const handleSubmitTipContinue = () => {
    setShowTermsModal(false);
    navigate("/submit");
  };

  if (isLoading) {
    return <LandingLoadingScreen />;
  }

  return (
    <div>
      <div className="relative container mx-auto max-w-screen-3xl">
        <div className="bg-gray-7 dark:bg-gray-7 min-h-dvh h-dvh flex flex-col">
          <Header type="landing" />
          <div className="flex-grow">
            <HeroSection setShowTermsModal={setShowTermsModal} />
          </div>
        </div>
        <AboutSection />
        <TipSection setShowTermsModal={setShowTermsModal} />
        <PrivacySection />
        <Footer mode="light" />

        {showDisclaimer && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-md z-50">
            <EmergencyDisclaimer
              onAccept={handleDisclaimerAccept}
              onClose={handleDisclaimerClose}
            />
          </div>
        )}

        {showTermsModal && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-md z-50">
            <TermsConditionsModal
              onAccept={handleSubmitTipContinue}
              onClose={() => setShowTermsModal(false)}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Landing;
